<template>
  <SendMessageInput
    v-model="message"
    :show-close-button="false"
    :title="title"
    :tips="recruitSitterTips"
    :label-name="inputLabel"
    :loading="messageSendLoading"
    @submit="emit('submit', $event)"
  >
    <Button
      v-if="noJobsExist"
      value="Add A Job"
      variant="outlined"
      size="medium"
      class="w-full mt-24"
      :href="`/job-post?jobPostReturnPath=${jobPostReturnPath}`"
    />
    <Dropdown
      v-else
      id="job-dropdown"
      :model-value="selectedJob"
      class="mt-16"
      label-name="Job"
      name="job"
      :options="jobOptions"
      @update:model-value="onSelectJob"
    />
  </SendMessageInput>
</template>

<script setup lang="ts">
import Button from '@/components/button/Button.vue';
import Dropdown from '@/components/dropdown/Dropdown.vue';
import SendMessageInput from '@/components/send_message_input/SendMessageInput.vue';

defineOptions({ name: 'RecruitNotBasic' });

const message = defineModel<string>({ required: true });

withDefaults(
  defineProps<{
    recruitSitterTips: string[];
    inputLabel: string;
    messageSendLoading: boolean;
    noJobsExist?: boolean;
    jobPostReturnPath?: string;
    jobOptions?: Array<{ display: string; value: string }>;
    selectedJob?: string;
    title?: string;
  }>(),
  {
    noJobsExist: false,
    jobPostReturnPath: '',
    jobOptions: () => [],
    selectedJob: '',
    title: 'Start the chat with your job',
  }
);

const emit = defineEmits<{
  (e: 'submit', note: string): void;
  (e: 'update:selectedJob', value: string | null): void;
}>();

function onSelectJob(value: string | null): void {
  emit('update:selectedJob', value);
}
</script>
